import type { FormApi } from 'final-form';

import type { TFields } from '../../components/form/models/index';

export const showValidFields = <T extends TFields>(form: FormApi<T>) => {
    form.getRegisteredFields().forEach(field => {
        const fieldState = form.getFieldState(field);

        // TODO написать отдельный тест-кейс с переходом с одного шага на другой как в анкете
        /* istanbul ignore next */
        if (fieldState?.valid) {
            /* istanbul ignore next */
            fieldState.focus();
            /* istanbul ignore next */
            fieldState.blur();
        }
    });
};
